import { Toast } from "primereact/toast";
import { useRef, useState } from "react";
import { IWebSite } from "../../models/WebSite";
import { EmptyTestingEmail } from "./EmptyTestingEmail";
import { Table } from "./Table";
import { Form } from "./Form";
import { IPermissionProps } from "../../models/Login";

export interface IModel {
    open: boolean,
    singleData: IWebSite,
    
}

export const TestingEmailSetting = (permissions: IPermissionProps) => {

    const [modal, setModal] = useState({ singleData: EmptyTestingEmail, open: false } as IModel);
    const [reload, setReload] = useState(false);
    const toast = useRef<any>(null); 

    const hideDialog = () => {
        setModal({ singleData: EmptyTestingEmail, open: false })
    };

    return (
        <>
            <Table permissions={permissions} setModal={setModal} toast={toast} reload={reload}></Table>
            <Form singleData={modal.singleData} open={modal.open} hideDialog={hideDialog} toast={toast} reload={reload} setReload={setReload}></Form>
            <Toast ref={toast} />
        </>
    );
}
